// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10WOP","footer":"styles_footer__2XuOf","passCodeTooltip":"styles_passCodeTooltip__2Etim"};